import { useQuery } from '@tanstack/react-query'
import { query } from '../graphql'

export const useActiveSpaceQuery = ({
  active_space_id,
  refetchOnWindowFocus = false
}) => {
  return useQuery({
    queryKey: ['active-space', active_space_id],
    queryFn: () => {
      return query({ query: 'getSpace', variables: { id: active_space_id } })
    },
    enabled: !!active_space_id,
    refetchOnWindowFocus
  })
}
